/*
 *
 * AmlPopupConfirm
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 23-Jul-2025
*/

import AmlPopupConfirm from './AmlPopupConfirmContainer'

export default AmlPopupConfirm
